import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmailTemplate  {
    _originalTypeClassName = "zPMO.BO.EmailTemplate";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmailTemplate.translate = translateService;
}
this.Inputs = [];
this.Recipients = [];
this.Id = null;
this.IsActive = false;
this.Name = null;
this.Description = null;
this.SubjectTemplate = null;
this.FromAddress = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsActive:any;
Name:any;
Description:any;
SubjectTemplate:any;
FromAddress:any;
Inputs:any;
BodyTemplate:any;
Recipients:any;
static setInputs = ($this, items) => {
                if (items == null) items = [];
                if ($this.Inputs == null) $this.Inputs = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Inputs.length > 0) {
                    Domain.EmailTemplate.removeInputs($this, $this.Inputs[0]);
                }

                Domain.EmailTemplate.addManyInputs($this, copyItems);
            }
static addManyInputs = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmailTemplate.addInputs($this, items[i]);
                }
            }
static addInputs = ($this, item) => {
                if ($this.Inputs == null) $this.Inputs = [];
                if (item == null || $this.Inputs.indexOf(item) > -1) return;
                $this.Inputs.push(item);
}
static addRangeInputs = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmailTemplate.addInputs($this, item));
            }
static removeInputs = ($this, item) => {
                if ($this == null || $this.Inputs == null || $this.Inputs.indexOf(item) === -1) return;
                var _index = $this.Inputs.indexOf(item);
                $this.Inputs.splice(_index, 1);
}
static clearInputs = ($this) => { $this.Inputs = null; }
static setBodyTemplate = ($this, value) => {
var oldValue = $this.BodyTemplate;
$this.BodyTemplate = value;
if (value != null) {
}
}
static setRecipients = ($this, items) => {
                if (items == null) items = [];
                if ($this.Recipients == null) $this.Recipients = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Recipients.length > 0) {
                    Domain.EmailTemplate.removeRecipients($this, $this.Recipients[0]);
                }

                Domain.EmailTemplate.addManyRecipients($this, copyItems);
            }
static addManyRecipients = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmailTemplate.addRecipients($this, items[i]);
                }
            }
static addRecipients = ($this, item) => {
                if ($this.Recipients == null) $this.Recipients = [];
                if (item == null || $this.Recipients.indexOf(item) > -1) return;
                $this.Recipients.push(item);
}
static addRangeRecipients = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmailTemplate.addRecipients($this, item));
            }
static removeRecipients = ($this, item) => {
                if ($this == null || $this.Recipients == null || $this.Recipients.indexOf(item) === -1) return;
                var _index = $this.Recipients.indexOf(item);
                $this.Recipients.splice(_index, 1);
}
static clearRecipients = ($this) => { $this.Recipients = null; }

static RenderBody(template: any,values: any): any{if (!(template?.IsActive)) {throw Error("Email template is inactive.");}
let renderedBody = "";
return renderedBody;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}